export const explainerSlugKey: { [key: string]: string } = {
    portfolioLandCover: 'portfolio-land-cover',
    portfolioCombinedVegetatedArea: 'portfolio-combined-vegetated-area',
    portfolioVegetationHealth: 'portfolio-vegetation-health',
    portfolioConnectivity: 'portfolio-connectivity',
    portfolioBiodiversityIntactnessIndex: 'portfolio-biodiversity-intactness-index',
    portfolioHumanModificationIndex: 'portfolio-human-modification-index',
    portfolioInvasiveSpecies: 'portfolio-invasive-species',
    portfolioIucnRedListSpecies: 'portfolio-iucn-red-list-species',
    portfolioCsrdFramework: 'portfolio-csrd-framework',
    portfolioTnfdFramework: 'portfolio-tnfd-framework',
    portfolioGriFramework: 'portfolio-gri-framework',
};

export const chartColors: { [string: string]: string } = {
    red: '#AD180E',
    orange: '#CF8515',
    green: '#2EAD0E',
    primary: '#076769',
};
